/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * UC Monitoring API
 * UC Monitoring: Call Quality + Room Utilization
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  CreateIntegrationDto,
  GetIntegrationDto,
  GetIntegrationStatusDto,
  IntegrationsControllerCreateIntegrationV1PathParameters,
  IntegrationsControllerDeleteIntegrationV1PathParameters,
  IntegrationsControllerGetIntegrationStatusV1PathParameters,
  IntegrationsControllerGetIntegrationV1PathParameters,
  IntegrationsControllerGetIntegrationsV1200AllOf,
  IntegrationsControllerGetIntegrationsV1PathParameters,
  IntegrationsControllerUpdateIntegrationV1PathParameters,
  UpdateIntegrationDto,
} from '../models';

@Injectable({ providedIn: 'root' })
export class IntegrationsService {
  private readonly http = inject(HttpClient);
  /**
   * @summary Get this client's integration enablement flags
   */

  getIntegrations<TData = IntegrationsControllerGetIntegrationsV1200AllOf>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
  }: IntegrationsControllerGetIntegrationsV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/uc-monitoring/v1/clients/${clientId}/integrations`);
  }
  /**
   * @summary Create this client's integration connection
   */

  createIntegration<TData = GetIntegrationDto>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: IntegrationsControllerCreateIntegrationV1PathParameters,
    createIntegrationDto: CreateIntegrationDto,
  ): Observable<TData> {
    return this.http.post<TData>(`/uc-monitoring/v1/clients/${clientId}/integrations`, createIntegrationDto);
  }
  /**
   * @summary Get a single integration
   */

  getIntegration<TData = GetIntegrationDto>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    id,
  }: IntegrationsControllerGetIntegrationV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/uc-monitoring/v1/clients/${clientId}/integrations/${id}`);
  }
  /**
   * @summary Update this client's integration enablement flag or rotate its credentials
   */

  updateIntegration<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, id }: IntegrationsControllerUpdateIntegrationV1PathParameters,
    updateIntegrationDto: UpdateIntegrationDto,
  ): Observable<TData> {
    return this.http.patch<TData>(`/uc-monitoring/v1/clients/${clientId}/integrations/${id}`, updateIntegrationDto);
  }
  /**
   * @summary Delete this client's integration
   */

  deleteIntegration<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    id,
  }: IntegrationsControllerDeleteIntegrationV1PathParameters): Observable<TData> {
    return this.http.delete<TData>(`/uc-monitoring/v1/clients/${clientId}/integrations/${id}`);
  }
  /**
   * @summary Live-check this integration's connection status and why it has that status
   */

  getIntegrationStatus<TData = GetIntegrationStatusDto>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    id,
  }: IntegrationsControllerGetIntegrationStatusV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/uc-monitoring/v1/clients/${clientId}/integrations/${id}/status`);
  }
}
